import { render, staticRenderFns } from "./MiniFavs.vue?vue&type=template&id=1ec81218&scoped=true&"
import script from "./MiniFavs.vue?vue&type=script&lang=js&"
export * from "./MiniFavs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec81218",
  null
  
)

export default component.exports